import React, { useState, useEffect, useContext } from "react";
import SummaryCards from "../../core/summary-card";
import { formatReports } from "./helper";
import TicketSummaryCards from "../../core/ticket-summary-card";
import MeanTimeCards from "../../core/mean-time-cards";
import IssueRaisingInfo from "../../core/issue-raising-info";
import PersonIcon from "@mui/icons-material/Person";
import "./index.scss";
import {
  Card,
  CardContent,
  Grid,
  Switch,
  FormControlLabel,
  Typography,
  Box,
} from "@mui/material";
import OverviewCards from "./overview-cards";
import { HTTP_METHODS, invokeApi, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import AppContext from "../../utils/context";
import { USER_ROLES } from "../../utils/constants";
import CustomBarChart from "./bar-chart";
import FailureInvoiceMonth from "../../pages/admin/dashboard/failure-invoice-month";

const Overview1 = ({ dashboardDetails, ticketCounts, isCallApis }) => {
  const [reportsDetails, setReportsDetails] = useState({});
  const [ageingData, setAgeingData] = useState([]);
  const [performer, setPerformer] = useState({
    monthly: "",
    yearly: "",
  });
  const [showAgeingOverview, setShowAgeingOverview] = useState(false);
  const [dateType, setDateType] = useState("invoiceDate");
  const [invoiceMonthData, setInvoiceMonthData] = useState({});

  const { userDetails = {} } = useContext(AppContext);
  const { overviewDashboardFilter = {} } = useContext(AppContext);
  const {
    majorAvgMttr,
    minorAvgMttr,
    majorAvgMttc,
    minorAvgMttc,
    minorServiceEngineerAssigned,
    minorAssignedToJirCompletion,
    minorResolveToClosure,
    minorJirCompletionToResolve,

    majorServiceEngineerAssigned,
    majorAssignedToJirCompletion,
    majorResolveToClosure,
    majorJirCompletionToResolve,
  } = dashboardDetails;
  const getAgeingData = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
    };
    const url =
      userDetails?.role === USER_ROLES.OEM
        ? REST_URLS.OEM_AGEING_DATA
        : REST_URLS.AGEING_DATA;
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${url}`, payload)
      .then((res) => {
        if (!res.message) {
          const result = [];
          for (let i in res) {
            result.push({ time: i, count: res[i] });
          }
          setAgeingData(result);
        }
      })
      .catch((err) => console.error(err));
  };

  const getPerformerData = (filters, type = "month") => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.PERFORMER}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          if (res.results.length) {
            const result = res?.results;
            const yaerPerformner = result.find((ele) => ele.type === "YEAR");
            const monthPerformner = result.find((ele) => ele.type === "MONTH");
            setPerformer((prevVal) => ({
              ...prevVal,
              yearly: yaerPerformner?.user?.name || "",
              monthly: monthPerformner?.user?.name || "",
            }));
          }
        }
      })
      .catch((err) => console.error(err));
  };

  const loadInvoiceMonthData = (params = {}) => {
    const payload = {
      ...params,
      ...overviewDashboardFilter,
      dateType: dateType,
    };
    const url =
      userDetails?.role === USER_ROLES.OEM
        ? REST_URLS.OEM_DASHBOARD_INVOICE_DATA
        : REST_URLS.DASHBOARD_INVOICE_DATA;
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${url}`, payload)
      .then((res) => {
        if (!res.message) {
          setInvoiceMonthData(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const MinorData = [
    {
      count: minorServiceEngineerAssigned,
      label: "Ticket Created date to Service Engineer Assigned date in hours",
    },
    {
      count: minorAssignedToJirCompletion,
      label: "Service Engineer Assigned date to JIR Completion date in days",
    },
    {
      count: minorJirCompletionToResolve,
      label: "JIR Completion date to HO Decision given in days",
    },
    {
      count: minorResolveToClosure,
      label: "HO Decision given date to Ticket Closure date in days",
    },
    {
      count: minorAvgMttc,
      label: "Ticket Created date to Ticket Closure date in days",
    },
  ];

  const MajorData = [
    {
      count: majorServiceEngineerAssigned,
      label: "Ticket Created date to Service Engineer Assigned date in hours",
    },
    {
      count: majorAssignedToJirCompletion,
      label: "Service Engineer Assigned date to JIR Completion date in days",
    },
    {
      count: majorJirCompletionToResolve,
      label: "JIR Completion date to HO Decision given in days",
    },
    {
      count: majorResolveToClosure,
      label: "HO Decision given date to Ticket Closure date in days",
    },
    {
      count: majorAvgMttc,
      label: "Ticket Created date to Ticket Closure date in days",
    },
  ];

  useEffect(() => {
    setReportsDetails(formatReports(dashboardDetails));
  }, [dashboardDetails]);

  const { maxStateIssue, minStateIssue } = reportsDetails;

  useEffect(() => {
    if (userDetails.role !== USER_ROLES.OEM) {
      getPerformerData();
    }
  }, []);

  useEffect(() => {
    if (isCallApis) {
      if (showAgeingOverview) {
        getAgeingData();
      } else {
        loadInvoiceMonthData();
      }
    }
  }, [showAgeingOverview, dateType, overviewDashboardFilter, isCallApis]);

  return (
    <div style={{ height: "100%" }}>
      <Card sx={{ minHeight: "35%" }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <Typography variant="h6" color="navy" align="center">
                MTTR-Major
              </Typography>
              {/* <MeanTimeCards
                title="MTTR - Major"
                resolveCount={majorAvgMttr}
                closedCount={majorAvgMttc}
              /> */}

              <Box className="mtt-container">
                {MajorData.map((item, index) => (
                  <div className="mtt-card" key={index}>
                    <div className="label-count">
                      <div className="label">{item?.label}</div>
                      <div className="count">{item?.count?.count || 0}</div>
                    </div>
                  </div>
                ))}
              </Box>
            </Grid>
            <Grid item md={6}>
              <Typography variant="h6" color="navy" align="center">
                MTTR-Minor
              </Typography>
              {/* <MeanTimeCards
                title="MTTR - Minor"
                resolveCount={minorAvgMttr}
                closedCount={minorAvgMttc}
              /> */}
              <Box className="mtt-container">
                {MinorData.map((item, index) => (
                  <div className="mtt-card" key={index}>
                    <div className="label-count">
                      <div className="label">{item?.label}</div>
                      <div className="count">{item?.count?.count || 0}</div>
                    </div>
                  </div>
                ))}
              </Box>
            </Grid>
          </Grid>
          <OverviewCards />
        </CardContent>
      </Card>

      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Grid container spacing={5}>
            <Grid item md={6}>
              <TicketSummaryCards
                title="Ticket summary"
                ticketCounts={ticketCounts}
                overviewDashboardFilter={overviewDashboardFilter}
                userDetails={userDetails}
              />
            </Grid>
            <Grid item md={6}>
              <IssueRaisingInfo
                data={[
                  {
                    label: "Maximum issue raising state",
                    ...maxStateIssue,
                  },
                  {
                    label: "Minimum issue raising state",
                    ...minStateIssue,
                  },
                ]}
              />
              {userDetails.role !== USER_ROLES.OEM && (
                <>
                  <div className="pf-month">
                    <div className="pf-month-info">
                      <div>{performer.monthly}</div>
                      <div>PERFORMER OF THE MONTH</div>
                    </div>
                    <PersonIcon style={{ color: "#102f77", fontSize: 80 }} />
                  </div>
                  <div className="pf-month">
                    <div className="pf-month-info">
                      <div>{performer.yearly || "-"}</div>
                      <div>PERFORMER OF THE YEAR</div>
                    </div>
                    <PersonIcon style={{ color: "#102f77", fontSize: 80 }} />
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card sx={{ mt: 2, height: "auto" }}>
        <CardContent>
          <FormControlLabel
            control={
              <Switch
                checked={showAgeingOverview}
                onChange={() => setShowAgeingOverview((prev) => !prev)}
                color="primary"
              />
            }
            label="Show Ticket Ageing Overview"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
          {showAgeingOverview ? (
            <CustomBarChart
              title="Tickets Ageing Overview"
              data={ageingData || []}
              xDataKey="time"
              bDataKey="count"
              height={150}
              xAxisLabel="Ageing No. Of Hours"
              yAxisLabel="Count"
            />
          ) : (
            <FailureInvoiceMonth
              inputData={invoiceMonthData}
              height={150}
              onDateTypeChange={(newDateType) => {
                setDateType(newDateType);
              }}
            />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Overview1;
